import { Role, Roles } from './Roles';

export enum EditableFields {
  // these are used in order edit flow to enable and dissable fields based on permission requirements

  // contract and property type
  ContactedBy = 'contactedBy',
  ContactType = 'contactType',
  ContactedVia = 'contractedVia',
  Represents = 'represents',
  Address = 'address',
  PropertyType = 'propertyType',
  YearBuilt = 'yearBuilt',
  SaleType = 'saleType',

  // coverage
  ProductType = 'productType',
  CoverageOptions = 'coverageOptions',
  SellersCoverage = 'sellersCoverage',

  // customer info
  Buyer = 'buyer',
  Seller = 'seller',

  // price adjustments
  PriceAdjustment = 'priceAdjustment',

  NoRenew = 'noRenew',
  CancelStatus = 'cancelStatus',

  // affiliates info
  InitiatingAgent = 'initiatingAgent',
  CoopAgent = 'coopAgent',
  PropertyManager = 'propertyManager',
  Escrow = 'escrow',
  TransCoordinator = 'transCoordinator'
}

export class EditPermissions {
  public static GetEditableFields(isOpenOrder?: boolean): Array<string> {
    var admin = [
      EditableFields.Address,
      EditableFields.Buyer,
      EditableFields.CancelStatus,
      EditableFields.ContactType,
      EditableFields.ContactedBy,
      EditableFields.ContactedVia,
      EditableFields.CoopAgent,
      EditableFields.CoverageOptions,
      EditableFields.Escrow,
      EditableFields.InitiatingAgent,
      EditableFields.NoRenew,
      EditableFields.PriceAdjustment,
      EditableFields.ProductType,
      EditableFields.PropertyManager,
      EditableFields.PropertyType,
      EditableFields.Represents,
      EditableFields.SaleType,
      EditableFields.Seller,
      EditableFields.SellersCoverage,
      EditableFields.TransCoordinator,
      EditableFields.YearBuilt
    ];
    var manager = [
      EditableFields.Address,
      EditableFields.Buyer,
      EditableFields.ContactType,
      EditableFields.ContactedBy,
      EditableFields.ContactedVia,
      EditableFields.CoopAgent,
      EditableFields.CoverageOptions,
      EditableFields.Escrow,
      EditableFields.InitiatingAgent,
      EditableFields.PriceAdjustment,
      EditableFields.PropertyManager,
      EditableFields.Represents,
      EditableFields.Seller,
      EditableFields.SellersCoverage,
      EditableFields.TransCoordinator,
      EditableFields.YearBuilt
    ];
    var associate = [EditableFields.PropertyManager];
    if (
      Role.CheckRoles([
        Roles.Admin,
        Roles.IBSAdmin,
        Roles.AccountingAdmin,
        Roles.AuthorizationAdmin,
        Roles.ServiceAdmin,
        Roles.PurchasingAdmin,
        Roles.MarketingAdmin
      ])
    ) {
      return admin;
    } else if (
      Role.CheckRoles([
        Roles.ServiceManager,
        Roles.MarketingManager,
        Roles.AccountingManager,
        Roles.PurchasingManager,
        Roles.AuthorizationManager,
        Roles.IBSManager
      ])
    ) {
      return !isOpenOrder ? manager : admin;
    } else if (
      Role.CheckRoles([
        Roles.IBSAssociate,
        Roles.ServiceAssociate,
        Roles.MarketingAssociate,
        Roles.AccountingAssociate,
        Roles.PurchasingAssociate,
        Roles.AuthorizationAssociate
      ])
    ) {
      return !isOpenOrder
        ? associate
        : associate.concat([
            EditableFields.Address,
            EditableFields.Buyer,
            EditableFields.CancelStatus,
            EditableFields.ContactType,
            EditableFields.ContactedBy,
            EditableFields.ContactedVia,
            EditableFields.CoopAgent,
            EditableFields.CoverageOptions,
            EditableFields.Escrow,
            EditableFields.InitiatingAgent,
            EditableFields.PriceAdjustment,
            EditableFields.ProductType,
            EditableFields.PropertyManager,
            EditableFields.PropertyType,
            EditableFields.Represents,
            EditableFields.SaleType,
            EditableFields.Seller,
            EditableFields.TransCoordinator,
            EditableFields.YearBuilt
          ]);
    }
    return associate;
  }

  public static CanEditField(field: string, isOpenOrder?: boolean): boolean {
    var editableFields = this.GetEditableFields(isOpenOrder);
    if (editableFields.includes(field)) {
      return true;
    }
    return false;
  }

  public static CanEditFields(fields: Array<string>, isOpenOrder?: boolean): boolean {
    var editableFields = this.GetEditableFields(isOpenOrder);
    var canEdit = false;
    fields.forEach(field => {
      if (editableFields.includes(field)) {
        canEdit = true;
        return;
      }
    });
    return canEdit;
  }
}



// WEBPACK FOOTER //
// ./src/_models/EditPermissions.ts